import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap space-y-5 lg:space-y-0"
}
const _hoisted_2 = { class: "relative w-full lg:w-[300px] rounded-2xl overflow-hidden bg-white border border-gray-900/[.04]" }
const _hoisted_3 = { class: "relative aspect-w-16 aspect-h-9" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "font-bold text-darkgray-800" }
const _hoisted_7 = { class: "w-full lg:w-[calc(100%-300px)] pl-5 space-y-1 text-darkgray-900" }
const _hoisted_8 = { class: "font-bold line-clamp-1 overflow-hidden text-ellipsis" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { key: 1 }

import { format } from 'date-fns'
import { computed, onMounted, ref } from 'vue';
import BranchService from "@/classes/Branch";
import { formatDate, formatTime } from '@/helpers/TimeFormatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentImageCard',
  props: {
    appointmentToday: {
        type: Object,
    }
},
  setup(__props) {

const props = __props;

const branchImage = ref(null)
const storageUrl = computed(() => process.env.VUE_APP_API_STORAGE_URL);

const fetchBranch = async () => {
    try {
        const response = await BranchService.editBranch(props.appointmentToday?.branch_id)

        const branchResponse = response.data.branch;

        if(branchResponse) {
            // branchImage.value = branchResponse.image_path ? `${storageUrl.value}${branchResponse.image_path}` : '/assets/images/shinagawa-bgc-branch.jpeg';
            branchImage.value = branchResponse.image_path ? branchResponse.full_image_path : '/assets/images/shinagawa-bgc-branch.jpeg';
        }
    }
    catch(error: any) {
        console.log(error)
    }
}

onMounted( () => {
    setTimeout(() => {
        if(props.appointmentToday?.branch_id) {
            fetchBranch();
        }   
    }, 1000);
})

return (_ctx: any,_cache: any) => {
  return (__props.appointmentToday)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: branchImage.value,
              alt: "",
              class: "absolute top-0 left-0 object-cover w-full h-full"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.appointmentToday.branch_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(__props.appointmentToday.package_name ?? 'Selected Procedures Only' ?? 'N/A'), 1),
          _createElementVNode("p", _hoisted_9, [
            _createTextVNode(_toDisplayString(_unref(formatDate)(__props.appointmentToday?.booking_date ?? new Date(), 'UTC','EEE, MMM dd')) + " ", 1),
            _createElementVNode("span", null, " | " + _toDisplayString(_unref(formatTime)(__props.appointmentToday?.booking_start_time ?? new Date(), 'UTC', 'h:mm a')) + " - " + _toDisplayString(_unref(formatTime)(__props.appointmentToday?.booking_end_time ?? new Date(), 'UTC', 'h:mm a')), 1)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, " No appointment scheduled for today "))
}
}

})